export default __webpack_public_path__ + "static/media/empty-state.bfe89060.svg";